import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { FrontPageState } from '../../../reducer';
import { toDateString } from '../../../../utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/autoplay';
import 'swiper/scss/pagination';
import TopBlockErrorBoundary from './TopBlockErrorBoundary';

export default function PaKryssBlock(): ReactElement {
  const { paKryss, isLoading } = useSelector((state: FrontPageState) => ({
    paKryss: state.paKryss,
    isLoading: state.isLoading.indexOf('pa_kryss') !== -1,
  }));

  return (
    <TopBlockErrorBoundary name="PaKryssBlock" title="På Kryss" message="Misslyckades ladda På Kryss">
      <div id="intro-articles" className="intro-segment section-part-third news-feed">
        <div className="media-feed-title page-title-box">
          <div className="media-feed-title-wrap page-title-box-inner content-bg">
            <div className="member-feed-header">
              <div className="member-feed-title">
                <h3 className="feed-title">
                  <span className="aligner-middle" />
                  <span className="media-feed-title-part">På Kryss</span>
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div id="pa-kryss--slideshow" className="section-content">
          {isLoading && (
            <div className="media-feed-loader">
              <div className="cssload-container">
                <ul className="cssload-flex-container">
                  <li>
                    <span className="cssload-loading" />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {!isLoading && (
            <Swiper
              modules={[Navigation, A11y, Autoplay, Pagination]}
              autoplay={{
                delay: 10_000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              pagination
              loop
              slidesPerView={1}
            >
              {paKryss.items.slice(0, 5).map((item) => (
                <SwiperSlide key={item.id}>
                  <div
                    className="article-slide-image"
                    style={{
                      backgroundImage: `url('${item.image}')`,
                    }}
                  />
                  <div className="article-slide-content">
                    <div className="article-slide-title-container">
                      <h3 className="article-slide-title">
                        <a href={item.link} tabIndex={-1}>
                          {item.label}
                        </a>
                      </h3>
                    </div>
                    <div className="article-slide-created">{toDateString(item.timestamp)}</div>
                    <div className="article-slide-text">{item.ingress}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
        <div className="article-slide-link">
          <a className="btn btn-default btn-feed" href="/pa-kryss/artiklar">
            Fler artiklar från På Kryss
          </a>
        </div>
      </div>
    </TopBlockErrorBoundary>
  );
}
